import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";
import {millisToDate} from "./utils";

/**
 * Update or create item (product table)
 * Item can be table, category or menu depending on type variable
 * @param product
 */
export function updateProductItem(product) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/product', JSON.stringify(product), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function updateProductMetaItem(productMeta) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/productMeta', JSON.stringify(productMeta), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateProductMetaItems(metas) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/productMetas', JSON.stringify(metas), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Product Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
/**
 * Update or create item (category table)
 * Item can be table, category or menu depending on type variable
 * @param product
 */
export function updateCategoryItem(category) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'admin/category', JSON.stringify(category), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Category Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateProductItems(products) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'admin/products', JSON.stringify(products), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Items update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function updateProductItemPos(products) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'admin/products/pos', JSON.stringify(products), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Items update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function updateCategoryItems(categories) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'admin/categories', JSON.stringify(categories), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Category Items update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getCategoryById(cid) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'admin/category?id=' + cid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}


export function getProductItemById(id) {
  return new Promise(function (resolve, reject) {
    console.log("getProductById " + id)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + id + '/item', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        errorHandler(error);
        reject(error)
      });
  })
}
export function getProductById(id) {
  return new Promise(function (resolve, reject) {
    console.log("getProductById " + id)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        errorHandler(error);
        reject(error)
      });
  })
}
export function markProductSupplierOrdered(id, ordered) {
  return new Promise(function (resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + id + '/mark?supplierOrdered='+ ordered, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        errorHandler(error);
        reject(error)
      });
  })
}
export function searchAllProducts(title, searchType = 'all', orderType = 'all') {
  return new Promise(function(resolve, reject){
    // console.log("getProductWithBarcode " + barcode, {
    //   headers: {
    //     "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
    //   }
    // });


    axios.get(process.env.ROOT_API + 'admin/products/all/search?words=' + title + '&type='+searchType + '&orderType=' + orderType, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        console.log("search product response ok");
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(err){
        errorHandler(err);
        reject(err);

      })
  })
}
export function searchProducts(title, merchantId, vendorId) {
  return new Promise(function(resolve, reject){
    // console.log("getProductWithBarcode " + barcode, {
    //   headers: {
    //     "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
    //   }
    // });
    axios.get(process.env.ROOT_API + 'admin/products/search?title=' + title + "&merchantId=" + merchantId + "&vendorId=" + vendorId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        console.log("search product response ok");
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(err){
        errorHandler(err);
        reject(err);

      })
  })
}
export function getProductWithBarcode(barcode) {
  return new Promise(function(resolve, reject){
    console.log("getProductWithBarcode " + barcode, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    });
    axios.get(process.env.ROOT_API + 'product/barcode/' + barcode, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        console.log("getProductWithBarcode response ok");
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(err){
        errorHandler(err);
        reject(err);

      })
  })
}
/**
 * Get products of category
 * @param id
 * @returns {Promise<unknown>}
 */
export function getProductsByCategory(cid, type = 'active', orderType = 'all') {
  return new Promise(function (resolve, reject) {
    console.log("getProductsByCategory " + cid)
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/products?categoryId=' + cid;
    if(type !== null && type.length > 0) {
      url += '&type='+ type;
    }
    if(orderType !== null && orderType.length > 0) {
      url += '&orderType=' + orderType;
    }
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getMerchantProducts(query) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/products?'+query;

    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getVendorProducts(vendorId) {
  return new Promise(function(resolve, reject){
    console.log("getVendorProducts " + vendorId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    });
    axios.get(process.env.ROOT_API + 'admin/vendor/products?vendorId=' + vendorId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        console.log("getVendorProducts response ok");
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error){
        errorHandler(error);
        reject(error)

      })
  })
}
/**
 * Get categories
 * @param id
 * @returns {Promise<unknown>}
 */
export function getCategories() {
  return new Promise(function (resolve, reject) {
    // console.log("getCategories")

    // let data = {
    //   success:true,
    //   item:[
    //     {
    //       title:"Cat A",
    //       pos: 0,
    //     },
    //     {
    //       title:"Cat B",
    //       pos: 1,
    //     },
    //     {
    //       title:"Cat C",
    //       pos: 2,
    //     },
    //   ]
    // }
    // resolve(data);
    axios.get(process.env.ROOT_API + 'admin/categories', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getProductStock(pid, pagination = null) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock " + pid);

    let urlPath = process.env.ROOT_API + 'admin/stocks?productId=' + pid;
    if(pagination != null) {
      urlPath += `&page=${pagination.page}`;
      urlPath += `&size=${pagination.size}`;
      urlPath += `&sort=${pagination.sort}`;
    }
    axios.get(urlPath, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        console.log(error);
        console.log(error.response);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getCategoryStock(cid, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock " + pid);
    axios.get(process.env.ROOT_API + 'category/' + cid + '/stock/' + from  + '/' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        console.log(error);
        console.log(error.response);
        errorHandler(error);
        reject(error)
      })
  })
}

// export function addStock(stock) {
//   return new Promise(function(resolve, reject){
//     axios.post(process.env.ROOT_API + 'stock', JSON.stringify(stock), {
//       headers: {
//         "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
//         "Content-Type": "application/json"
//       }
//     }).then(function(response){
//       let data = response.data;
//       resolve(data);
//     }).catch(function(err){
//       reject(err);
//     })
//
//   })
// }

export function addStock(stock) {
  return new Promise(function(resolve, reject){
    axios.post(process.env.ROOT_API + 'admin/product/stock', JSON.stringify(stock), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(error) {
      console.log(error);
      console.log(error.response);
      errorHandler(error);
      reject(error)
    })

  })
}
export function submitStockUnitTypeChange(id, weight, value) {
  return new Promise(function(resolve, reject){
    axios.get(process.env.ROOT_API + 'admin/stock/unitChange?id=' + id + '&weight=' + weight + "&value=" + value, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(error) {
      console.log(error);
      console.log(error.response);
      errorHandler(error);
      reject(error)
    })

  })
}

export function deleteStock(sId) {
  return new Promise(function(resolve, reject){
    axios.get(process.env.ROOT_API + 'stock/delete?id='+sId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(error) {
      console.log(error);
      console.log(error.response);
      errorHandler(error);
      reject(error)
    })

  })
}

export function stockQuery(query) {
  return new Promise(function(resolve, reject) {
    console.log("stockQuery " + query);
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/stocks/query?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getStockListWithInvoiceNumber(invoiceNumber) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock invoiceNumber: " + invoiceNumber);
    axios.get(process.env.ROOT_API + 'stocks/invoice/' + invoiceNumber, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error);
      })
  })
}

export function updateProductStock(pid) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'product/' + pid + '/updateStock', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

/**
 * Get Stock of product by state
 * @param pid
 * @param state
 * @returns {Promise<unknown>}
 */
export function getProductStockListByState(pid, state) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&state=' + state, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

export function getLowStockProduct() {
  return new Promise(function(resolve, reject) {
    console.log("getLowStockProduct ");
    axios.get(process.env.ROOT_API + 'admin/products/lowStock', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}
export function getNoMarginTaggedProduct() {
  return new Promise(function(resolve, reject) {
    console.log("getLowStockProduct ");
    axios.get(process.env.ROOT_API + 'admin/products/nomargin', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}
export function getEndingStockProduct(days) {
  return new Promise(function(resolve, reject) {
    console.log("getLowStockProduct ");
    axios.get(process.env.ROOT_API + 'admin/products/stock/ending/' + days, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

export function calculateEndingStockProduct(pId) {
  return new Promise(function(resolve, reject) {
    console.log("getLowStockProduct ");
    axios.get(process.env.ROOT_API + 'admin/product/' + pId + '/stock/lasting/calculate', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductStockListByStateRange(pid, stateFrom, stateTo) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&stateFrom=' + stateForm + '&stateTo=' + stateTo, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

export function getProductStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductSoldStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks/sold/state/time?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductInStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks/in/state/time?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}


export function deleteProduct(pid) {
  return new Promise(function(resolve, reject) {
    console.log("deleteProduct " + pid);
    axios.delete(process.env.ROOT_API + 'admin/product?id=' + pid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

export function deleteCategory(cid) {
  return new Promise(function(resolve, reject) {
    console.log("deleteCategory " + cid);
    axios.delete(process.env.ROOT_API + 'admin/category?id=' + cid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        errorHandler(error);
        reject(error)
      })
  })
}

export function getProductsStockStatusReportExcel(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/products/current/stock/status/report', JSON.stringify(form), {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductReport() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/report', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function updateProductBulk(cats) {
  return new Promise(function(resolve, reject){
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/products/bulk', JSON.stringify(cats), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      EventBus.$emit("showLoading", false);
      let data = response.data;
      console.log("updateProductBulk")
      console.log(data);
      resolve(data);
    }).catch(function(error){
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    })

  })
}

export function assetStatement() {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/statement/asset', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function assetStatementPDF(report) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/asset/pdf', JSON.stringify(report), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function assetStatementExcel(report) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/asset/excel', JSON.stringify(report), {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getDocuments(type, from, to) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/documents?type='+type + "&from=" + from + "&to=" + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function stockValueReportExcel() {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/statement/stock/report/excel', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getNewProduct(cid) {
  let product = {
    id:0,
    categoryId:cid,
    vendorId:0,
    parentId:0,
    parent:null,
    children:[],
    code:'',
    title:'',
    pos:0,
    stockType:'stock',
    minStock:0,
    currentStock:0,
    unit:'EA',
    unitAmount:1,
    stockQuantity:1,
    sourcePrice:0,
    sourcePriceFloat:0.00,
    marginRate:0,
    marginAmount:0,
    price:0,
    priceFloat:0.00,
    taxRate:2000,
    available:true,
    barCode:'',
    productBarCode:'',
    canOrderKokoro:true,
    canOrderVendor:false,
    canOrderWeb:false,
    useVariablePrice: false,
    variablePriceUnit:'',

    weightFloat:0.00,
    weight:0,
    imageUrls:[],
    tags:[],
    vendors:[],
    suppliers:[],
    deleted:false,
    stockUnitType:'ea',
    noMarginTags:[],
    inventoryPriceFloat:0.00,
    inventoryUnitPriceFloat:0.00,
    inventoryMarginFloat:0.00,
    expectedEndDate:'',
    originalTitle:'New Product',
    highlightProduct:false,
    productColourCode:0,
  }
  return product;
}

export function getNewStock(pid, type, product) {
  let stock = {
    id:0,
    merchantId:0,
    productId:pid,
    vendorId:0,
    type:type,
    amount:0,
    amountWeight:0,
    amountWeightFloat:0.00,
    diff:0,
    diffWeight:0,
    diffWeightFloat:0.00,
    unitPrice:0,
    unitPriceFloat:0.00,
    totalPrice:0.00,
    totalPriceFloat:0.00,
    taxRate:product.taxRate,
    tax:0.00,
    stockDate:millisToDate(new Date().getTime(), '-'),
    finalDue:0.00,
    title:'',
    description:'',
    noVendorRequired: false,
    inventoryId:0,
    documents:[],
    stockUnitType:product.stockUnitType,
  }
  return stock;
}
export function getProductPendingMidstock(pId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + pId + '/pending/midstocks', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getProductListReport() {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/products/report/excel', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getChildProductListReport() {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/children/list', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getProductFullStockReport(pId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + pId + '/stocks/excel', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getCategoryProductsFullStockReport(cId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/category/' + cId + '/products/stocks/excel', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getAllProductsMigrationFullStockReport(catId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/products/stocks/migration/excel?categoryId='+catId, {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getProductsMigrationFullStockReport(pId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + pId + '/stocks/migration/excel', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getProductInventories(pId) {
  return new Promise(function(resolve, reject) {
    console.log("Get inventori list");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + pId + '/inventories', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}

export function getInventoryStocks(id) {
  return new Promise(function(resolve, reject) {
    console.log("Get inventory stock list");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/inventory/' + id + '/stocks', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function createNewInventoryItem(product) {
  return {
    id:0,
    productId: product.id,
    originalBalance:0,
    balance:0,
    weight:0,
    weightFloat:0.00,
    pricePerWeight: 0,
    pricePerWeightFloat: 0.00,
    vat:0,
    vatFloat:0.00,
    net:0,
    netFloat:0.00,
    gross:0,
    grossFloat:0.00,
    vatRate:product.taxRate,
    area:'',
    location:'',
    section:'',
    unitPrice:0,
    unitPriceFloat:0.00,
    batchCode:'',
    expiryDate:'',
    noVendorRequired: false,
    orderNumber: '',
    description:'',
    vendorId:0,

  };

}
export function addNewInventory(item) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/product/inventory/in', JSON.stringify(item), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function correctInventory(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/correction', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeInventoryInventory(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/changelocation', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeInventoryPrimeCost(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/primeCost', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeInventorySellingPrice(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/price', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeInventoriesOrders(pId, list) {
  return new Promise(function (resolve, reject) {
    console.log("reordering inventories ")
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/inventories/product/' + pId + '/reorder', JSON.stringify(list), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function moveInventoryInventory(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/move', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function editInventoryInventory(form) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/edit', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deactivateInventory(id, active) {
  return new Promise(function (resolve, reject) {
    console.log("deactivate ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/inventory/' + id + '/active/' + active, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function stockOutFromInventory(stock) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/inventory/stockout', JSON.stringify(stock), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getProductTracking(id, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("Get inventory stock list");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + id + '/trackings?from=' + from + "&to=" + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductTrend(id) {
  return new Promise(function(resolve, reject) {
    console.log("Get inventory stock list");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/product/' + id + '/trends', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getAreaList() {
  let list = ['3', '4', '27'];
  return list;
}
export function getLocationList() {
  return ['0', '1'];
}
export function getSectionList() {
  return ['A', 'AA', 'B', 'BB', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
}



// WEBPACK FOOTER //
// ./src/api/product.js